import { Button, Center, Group, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconFigmaArrowRight, IconFigmaCheck } from '@/assets/icons';
import { AuthCard } from '@/features/auth/components/AuthCard';
import { brandTextStyle } from '@/features/auth/components/authFieldStyles';
import { formatRole } from '@/utils/format';

interface InvitationAcceptedCardProps {
  orgName: string;
  role: string;
}

export const InvitationAcceptedCard = ({ orgName, role }: InvitationAcceptedCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AuthCard p={32} w={{ base: '100%', md: 420 }}>
      <Stack align="center" gap={24}>
        <Center
          w={56}
          h={56}
          style={{
            borderRadius: 12,
            backgroundColor: 'var(--color-status-success-soft)',
            color: 'var(--color-status-success)'
          }}
        >
          <IconFigmaCheck size={24} />
        </Center>
        <Stack align="center" gap={8}>
          <Title order={2} fz={24} fw={700} ta="center" style={brandTextStyle}>
            {t('acceptInvite.successTitle')}
          </Title>
          <Text size="sm" ta="center" style={{ color: 'var(--color-text-secondary)' }}>
            {t('acceptInvite.successMessage', { orgName })}
          </Text>
        </Stack>

        <Stack gap={8} w="100%">
          <Group
            justify="space-between"
            px={16}
            py={10}
            style={{
              borderRadius: 6,
              backgroundColor: 'var(--color-bg-surface-2)',
              border: '1px solid var(--color-border-default)'
            }}
          >
            <Text
              fz={11}
              tt="uppercase"
              style={{ color: 'var(--color-text-muted)', letterSpacing: 0.4 }}
            >
              {t('acceptInvite.successOrgLabel')}
            </Text>
            <Text fz={13} fw={600} style={{ color: 'var(--color-text-primary)' }}>
              {orgName}
            </Text>
          </Group>
          <Group
            justify="space-between"
            px={16}
            py={10}
            style={{
              borderRadius: 6,
              backgroundColor: 'var(--color-bg-surface-2)',
              border: '1px solid var(--color-border-default)'
            }}
          >
            <Text
              fz={11}
              tt="uppercase"
              style={{ color: 'var(--color-text-muted)', letterSpacing: 0.4 }}
            >
              {t('acceptInvite.successRoleLabel')}
            </Text>
            <Text fz={13} fw={600} style={{ color: 'var(--color-text-primary)' }}>
              {formatRole(role)}
            </Text>
          </Group>
        </Stack>

        <Button
          fullWidth
          rightSection={<IconFigmaArrowRight size={15} />}
          onClick={() => navigate('/login')}
        >
          {t('acceptInvite.successLoginButton')}
        </Button>
      </Stack>
    </AuthCard>
  );
};
